import {getEventTicketLimitPerOrder} from '@wix/wix-events-commons-statics'
import {connect} from '../../../../../../../../commons/components/runtime-context/connect'
import {getEvent} from '../../../../../selectors/event'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {TicketLimitReachedRuntimeProps} from './interfaces'
import {TicketLimitReached as Presentation} from './ticket-limit-reached'

const mapRuntime = ({state, actions: {setSeatingError}}: DetailsPageAppProps): TicketLimitReachedRuntimeProps => ({
  ticketLimitPerOrder: getEventTicketLimitPerOrder(getEvent(state)),
  setSeatingError,
})

export const TicketLimitReached = connect<{}, TicketLimitReachedRuntimeProps>(mapRuntime)(Presentation)
